import {defineMessages} from 'react-intl';

export default defineMessages({
	close: {
		id: 'plp.refinements.close',
		defaultMessage: 'Filters',
	}
});